import { enc } from './core.js';
export function pricesApi(c) {
    const base = (localId) => `/locals/${enc(localId)}/prices`;
    return {
        preview: (localId, body) => c.post(`${base(localId)}/bulk-preview`, body),
        apply: (localId, body) => c.post(`${base(localId)}/bulk-apply`, body),
        history: (localId, query = {}) => c.get(`${base(localId)}/history`, { query: query }),
        batches: (localId, query = {}) => c.get(`${base(localId)}/batches`, { query: query }),
        revert: (localId, batchId) => c.post(`${base(localId)}/batches/${enc(batchId)}/revert`),
    };
}
//# sourceMappingURL=prices.js.map